import React from "react";

const Iframe = ({ url }) => {
  return (
    <iframe
      title="theMap Checkout Form"
      id="themap__checkout"
      frameBorder="0"
      allowpaymentrequest="true"
      width="320"
      height="500"
      scrolling="no"
      src={url}
    ></iframe>
  );
};

export default Iframe;
